/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Brand creative assets shared across all activation types
 * @export
 * @interface BrandActivationCreative
 */
export interface BrandActivationCreative {
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    displayName?: string;
    /**
     * Any colour the API accepts —
     * @type {string}
     * @memberof BrandActivationCreative
     */
    displayColor?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    logoAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    logo1x1AssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    bannerAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    backgroundImageAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    ctaText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    rewardImageAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    revealText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    ctaButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    brandLinkText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    questHeader?: string;
    /**
     * Any colour the API accepts —
     * @type {string}
     * @memberof BrandActivationCreative
     */
    ctaStripColor?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    playableAdLayout?: BrandActivationCreativePlayableAdLayoutEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    headlineFont?: BrandActivationCreativeHeadlineFontEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    completeHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    completeSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    completeButtonText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    claimedHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    claimedSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    claimedSponsorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    claimedCtaText?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    claimedCtaUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    cappedHeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    cappedSubtext?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandActivationCreative
     */
    cappedSponsorMessage?: string;
}


/**
 * @export
 */
export const BrandActivationCreativePlayableAdLayoutEnum = {
    STACKED: 'STACKED',
    SPLIT: 'SPLIT'
} as const;
export type BrandActivationCreativePlayableAdLayoutEnum = typeof BrandActivationCreativePlayableAdLayoutEnum[keyof typeof BrandActivationCreativePlayableAdLayoutEnum];

/**
 * @export
 */
export const BrandActivationCreativeHeadlineFontEnum = {
    ARCHIVO_BLACK: 'ARCHIVO_BLACK',
    MONTSERRAT: 'MONTSERRAT',
    NUNITO_SANS: 'NUNITO_SANS',
    TEKO: 'TEKO'
} as const;
export type BrandActivationCreativeHeadlineFontEnum = typeof BrandActivationCreativeHeadlineFontEnum[keyof typeof BrandActivationCreativeHeadlineFontEnum];


/**
 * Check if a given object implements the BrandActivationCreative interface.
 */
export function instanceOfBrandActivationCreative(value: object): value is BrandActivationCreative {
    return true;
}

export function BrandActivationCreativeFromJSON(json: any): BrandActivationCreative {
    return BrandActivationCreativeFromJSONTyped(json, false);
}

export function BrandActivationCreativeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandActivationCreative {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'displayColor': json['displayColor'] == null ? undefined : json['displayColor'],
        'logoAssetId': json['logoAssetId'] == null ? undefined : json['logoAssetId'],
        'logo1x1AssetId': json['logo1x1AssetId'] == null ? undefined : json['logo1x1AssetId'],
        'bannerAssetId': json['bannerAssetId'] == null ? undefined : json['bannerAssetId'],
        'backgroundImageAssetId': json['backgroundImageAssetId'] == null ? undefined : json['backgroundImageAssetId'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'ctaText': json['ctaText'] == null ? undefined : json['ctaText'],
        'rewardImageAssetId': json['rewardImageAssetId'] == null ? undefined : json['rewardImageAssetId'],
        'revealText': json['revealText'] == null ? undefined : json['revealText'],
        'ctaButtonText': json['ctaButtonText'] == null ? undefined : json['ctaButtonText'],
        'brandLinkText': json['brandLinkText'] == null ? undefined : json['brandLinkText'],
        'questHeader': json['questHeader'] == null ? undefined : json['questHeader'],
        'ctaStripColor': json['ctaStripColor'] == null ? undefined : json['ctaStripColor'],
        'playableAdLayout': json['playableAdLayout'] == null ? undefined : json['playableAdLayout'],
        'headlineFont': json['headlineFont'] == null ? undefined : json['headlineFont'],
        'completeHeadline': json['completeHeadline'] == null ? undefined : json['completeHeadline'],
        'completeSubtext': json['completeSubtext'] == null ? undefined : json['completeSubtext'],
        'completeButtonText': json['completeButtonText'] == null ? undefined : json['completeButtonText'],
        'claimedHeadline': json['claimedHeadline'] == null ? undefined : json['claimedHeadline'],
        'claimedSubtext': json['claimedSubtext'] == null ? undefined : json['claimedSubtext'],
        'claimedSponsorMessage': json['claimedSponsorMessage'] == null ? undefined : json['claimedSponsorMessage'],
        'claimedCtaText': json['claimedCtaText'] == null ? undefined : json['claimedCtaText'],
        'claimedCtaUrl': json['claimedCtaUrl'] == null ? undefined : json['claimedCtaUrl'],
        'cappedHeadline': json['cappedHeadline'] == null ? undefined : json['cappedHeadline'],
        'cappedSubtext': json['cappedSubtext'] == null ? undefined : json['cappedSubtext'],
        'cappedSponsorMessage': json['cappedSponsorMessage'] == null ? undefined : json['cappedSponsorMessage'],
    };
}

export function BrandActivationCreativeToJSON(json: any): BrandActivationCreative {
    return BrandActivationCreativeToJSONTyped(json, false);
}

export function BrandActivationCreativeToJSONTyped(value?: BrandActivationCreative | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'displayColor': value['displayColor'],
        'logoAssetId': value['logoAssetId'],
        'logo1x1AssetId': value['logo1x1AssetId'],
        'bannerAssetId': value['bannerAssetId'],
        'backgroundImageAssetId': value['backgroundImageAssetId'],
        'externalUrl': value['externalUrl'],
        'ctaText': value['ctaText'],
        'rewardImageAssetId': value['rewardImageAssetId'],
        'revealText': value['revealText'],
        'ctaButtonText': value['ctaButtonText'],
        'brandLinkText': value['brandLinkText'],
        'questHeader': value['questHeader'],
        'ctaStripColor': value['ctaStripColor'],
        'playableAdLayout': value['playableAdLayout'],
        'headlineFont': value['headlineFont'],
        'completeHeadline': value['completeHeadline'],
        'completeSubtext': value['completeSubtext'],
        'completeButtonText': value['completeButtonText'],
        'claimedHeadline': value['claimedHeadline'],
        'claimedSubtext': value['claimedSubtext'],
        'claimedSponsorMessage': value['claimedSponsorMessage'],
        'claimedCtaText': value['claimedCtaText'],
        'claimedCtaUrl': value['claimedCtaUrl'],
        'cappedHeadline': value['cappedHeadline'],
        'cappedSubtext': value['cappedSubtext'],
        'cappedSponsorMessage': value['cappedSponsorMessage'],
    };
}

